<div *ngIf="isMobile">
  <app-summary-mobile [jobId]="job.quote_ID"></app-summary-mobile>
</div>
<div *ngIf="!isMobile">
  <app-summary-desktop></app-summary-desktop>
</div>
